import { Trans } from '@lingui/macro';
import { Paragraph } from '@pocketlaw/tetris/deprecated';
import { MagnifyingGlassInBadgeSvg } from './MagnifyingGlassInBadgeSvg';
import { Container } from './styled';
export function SearchResultsNoMatch() {
    return (<Container>
      <MagnifyingGlassInBadgeSvg />
      <Paragraph appearance="neutral" size="base" weight="semibold" noMargin>
        <Trans>No matching results</Trans>
      </Paragraph>
      <Paragraph appearance="neutral" size="base" noMargin>
        <Trans>Try searching for something else</Trans>
      </Paragraph>
    </Container>);
}
